export const EMPLOYEE_KPIS_LOCAL_STORAGE_KEY = 'salesEmployeeKpis'
